export default __webpack_public_path__ + "static/media/Small-Distributor-Assembly.2eac8b52.jpg";